module.exports = __webpack_public_path__ + "static/injection-schedule-chart-5d161fd5a694cc7a6b72a9e4cdc33c88.png";